import { gql } from "graphql-request";

export const GET_ALL_LEADERBOARDS = gql`
  query GetAllLeaderboards($orgId: String, $pageNo: Int, $pageSize: Int) {
    getleaderboards(
      where: { OrganizationIds: { contains: $orgId } }
      order: [{ field: "points", direction: DESC }]
      paging: { pageNo: $pageNo, pageSize: $pageSize }
    ) {
      items {
        ItemId
        CreatedBy
        CreatedDate
        LastUpdatedDate
        points
        achievementCount
        period
      }
      totalCount
      pageNo
      pageSize
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;

export const GET_LEADERBOARD_BY_USER = gql`
  query GetLeaderboardByUser($filter: String!, $orgId: String) {
    getleaderboards(
      where: {
        CreatedBy: { eq: $filter }
        OrganizationIds: { contains: $orgId }
      }
      order: [{ field: "points", direction: DESC }]
      paging: { pageNo: 1, pageSize: 1 }
    ) {
      items {
        ItemId
        CreatedBy
        CreatedDate
        LastUpdatedDate
        points
        achievementCount
        period
      }
      totalCount
    }
  }
`;

export const DELETE_LEADERBOARD_BY_USER = gql`
  mutation DeleteLeaderboardByUser($filter: String!, $orgId: String) {
    deleteleaderboard(
      where: {
        CreatedBy: { eq: $filter }
        OrganizationIds: { contains: $orgId }
      }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      message
    }
  }
`;

// Bulk delete: removes every leaderboard entry the user created in one request.
export const DELETE_MANY_LEADERBOARD_BY_USER = gql`
  mutation DeleteManyLeaderboardByUser($filter: String!, $orgId: String) {
    deleteManyleaderboard(
      where: {
        CreatedBy: { eq: $filter }
        OrganizationIds: { contains: $orgId }
      }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      message
    }
  }
`;

export const INSERT_LEADERBOARD = gql`
  mutation InsertLeaderboard(
    $points: Int!
    $achievementCount: Int!
    $period: String
    $organizationIds: [String]
  ) {
    insertleaderboard(
      input: {
        points: $points
        achievementCount: $achievementCount
        period: $period
        OrganizationIds: $organizationIds
      }
    ) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const UPDATE_LEADERBOARD = gql`
  mutation UpdateLeaderboard(
    $itemId: String!
    $points: Int!
    $achievementCount: Int!
    $period: String
  ) {
    updateleaderboard(
      where: { ItemId: { eq: $itemId } }
      input: {
        points: $points
        achievementCount: $achievementCount
        period: $period
      }
    ) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const UPDATE_LEADERBOARD_POINTS_ONLY = gql`
  mutation UpdateLeaderboardPoints($itemId: String!, $points: Int!) {
    updateleaderboard(
      where: { ItemId: { eq: $itemId } }
      input: { points: $points }
    ) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const UPDATE_LEADERBOARD_RESET = gql`
  mutation ResetLeaderboardPoints($itemId: String!, $period: String) {
    updateleaderboard(
      where: { ItemId: { eq: $itemId } }
      input: { points: 0, period: $period }
    ) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

// Stamps the season onto an entry without touching its points. Used to migrate
// legacy rows (no period) into the current season on first run.
export const UPDATE_LEADERBOARD_PERIOD = gql`
  mutation StampLeaderboardPeriod($itemId: String!, $period: String) {
    updateleaderboard(
      where: { ItemId: { eq: $itemId } }
      input: { period: $period }
    ) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;
